import {types} from './types';

const initialState = {
    list: [],
}

export function objectOrganizationReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_LIST_ORGANIZATION:
            return { ...state, list: action.payload};
        default:
            return state
    }
}